import React from "react";
import { ScribbleArrow, CompassRose, StayAbnormalStamp, PeakMark } from "./NotebookDoodles";
import { ARGENTARIO_COORDS } from "./EditorialLabel";

const ACID = "#C9FF3D";
const PAPER = "#F4EEE0";

/* Hand note — rider's pencil on the field map. `size` = total width in px. */
function HandSticker({ text, size = 160, tilt = 0, arrow = true, flip = false }) {
    return (
        <div style={{ width: size, transform: `rotate(${tilt}deg)` }} className="inline-flex items-center gap-1 select-none">
            {flip && arrow && <ScribbleArrow size={size * 0.34} rotate={160} />}
            <span className="font-display italic uppercase text-abnormal-acid leading-none whitespace-nowrap"
                style={{ fontSize: size * 0.24, textDecoration: "underline", textDecorationStyle: "wavy", textDecorationThickness: 1.5, textUnderlineOffset: 6 }}>
                {text}
            </span>
            {!flip && arrow && <ScribbleArrow size={size * 0.34} rotate={-20} />}
        </div>
    );
}

export function StickerKeepLeft({ size = 170, tilt = -4 }) { return <HandSticker text="keep left" size={size} tilt={tilt} flip />; }
export function StickerRocks({ size = 150, tilt = 3 }) { return <HandSticker text="rocks!" size={size} tilt={tilt} />; }
export function StickerSendIt({ size = 150, tilt = -6 }) { return <HandSticker text="send it" size={size} tilt={tilt} />; }
export function StickerSketchy({ size = 160, tilt = 5 }) { return <HandSticker text="sketchy" size={size} tilt={tilt} />; }
export function StickerMindBoars({ size = 200, tilt = -3 }) { return <HandSticker text="mind the boars" size={size} tilt={tilt} arrow={false} />; }

/* Rectangular rubber stamp — coords + field-note label */
export function StickerCoords({ size = 180, tilt = -3 }) {
    return (
        <div style={{ width: size, transform: `rotate(${tilt}deg)`, borderColor: ACID, color: ACID, opacity: 0.9 }}
            className="border-2 px-2 py-1 select-none text-center mix-blend-screen">
            <p className="font-vt uppercase tracking-[0.25em] leading-tight" style={{ fontSize: size * 0.06 }}>ABN · FIELD NOTE</p>
            <p className="font-display uppercase leading-none" style={{ fontSize: size * 0.13 }}>{ARGENTARIO_COORDS}</p>
            <p className="font-vt uppercase tracking-[0.3em] leading-tight" style={{ fontSize: size * 0.055 }}>MONTE ARGENTARIO · MMXXVI</p>
        </div>
    );
}

/* Trail-sign arrow — like the painted markers on Argentario rocks */
export function StickerTrailSign({ size = 140, tilt = 0 }) {
    return (
        <svg viewBox="0 0 140 60" width={size} style={{ transform: `rotate(${tilt}deg)` }} aria-hidden="true">
            <path d="M6,14 H100 L134,30 L100,46 H6 Z" fill="none" stroke={ACID} strokeWidth="2.5" strokeLinejoin="round" />
            <text x="18" y="37" fill={PAPER} fontFamily="Teko, Impact, sans-serif" fontSize="22" letterSpacing="2">ENDURO →</text>
        </svg>
    );
}

export function StickerCompass({ size = 90, tilt = 0 }) { return <CompassRose size={size} rotate={tilt} />; }
export function StickerStay({ size = 110, tilt = -8 }) { return <StayAbnormalStamp size={size} rotate={tilt} />; }
export function StickerPeak({ size = 120, tilt = 0 }) {
    return (
        <div style={{ width: size, transform: `rotate(${tilt}deg)` }} className="inline-flex flex-col items-center select-none">
            <PeakMark size={size * 0.4} />
            <span className="font-vt uppercase tracking-[0.25em] text-abnormal-acid" style={{ fontSize: size * 0.075 }}>P. Telegrafo · 635 m</span>
        </div>
    );
}
